import { tns } from "tiny-slider";

jQuery(function($) {
    
     // Product image gallery
    if( document.getElementsByClassName('flex-control-nav').length ){
        let product_slider = tns({
            container: '.flex-control-nav',
            items: 3,
            gutter: 10,
            controls: true,
            controlsPosition: "bottom",
            nav: false,
            controlsText: [ 
                '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M9.4 256l11.3-11.3 192-192L224 41.4 246.6 64 235.3 75.3 54.6 256 235.3 436.7 246.6 448 224 470.6l-11.3-11.3-192-192L9.4 256z"/></svg>', 
                '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M310.6 256l-11.3 11.3-192 192L96 470.6 73.4 448l11.3-11.3L265.4 256 84.7 75.3 73.4 64 96 41.4l11.3 11.3 192 192L310.6 256z"/></svg>' 
            ],
            loop: false,
            rewind: true
        });
    }

    // Tabs on product page
    function product_tabs(){

        const productTabs = document.querySelectorAll('.product-tab');
        
        if(productTabs){
            productTabs.forEach( tab => tab.querySelector('button').addEventListener('click', () => tab.classList.toggle('active') ))
        }

    }
    product_tabs();

    // product single: moves magnifying glass to bottom right corner
    setTimeout( () => place_image_gallery_icons(), 100 );
    window.addEventListener( 'resize', () => place_image_gallery_icons() ) // on resize


    function place_image_gallery_icons(){
        const magnifying_glass = document.querySelector('.woocommerce-product-gallery__trigger');
        const wishlist_icon = document.querySelector('.wishlist-toggle');

        if(magnifying_glass || wishlist_icon ){
        
            const flex_viewport = document.querySelector('.flex-viewport');
        
            if( flex_viewport ){
                const height = parseFloat(flex_viewport.style.height.replace( 'px', '' ));

                if(magnifying_glass){
                    magnifying_glass.style.top = (height - 46) + 'px' ;
                }
                
                if(wishlist_icon){
                    wishlist_icon.style.top = (height - 46) + 'px' ;
                    wishlist_icon.style.display = 'block';
                }

            }
        }
    }

    function product_storelocator_map(){

        let locator_toggle = document.querySelector('#store-locator-toggle');

        if( ! locator_toggle ){
            return;
        }

        locator_toggle.addEventListener( 'click', show_map );

    }
    product_storelocator_map();

    function show_map(e){

        let map = document.querySelector('body.single-product #product-store-locator');
        
        if( ! map ) return;

        map.classList.toggle('visible');
        $(map).fadeToggle();
        
        map.addEventListener('click', hide_map );
        
    }
    
    function hide_map(e){
        
        if( "product-store-locator" == e.target.id ){
            let map = document.querySelector('body.single-product #product-store-locator');
            $(map).fadeToggle();
            setTimeout( () => map.classList.toggle('visible'), 1000);
            
            map.removeEventListener('click', hide_map );
        }

    }

    // Product page SKU
    $( 'form.variations_form' ).on( 'found_variation', function( event, variation ) {

        if( variation.sku ){
            let element = document.getElementById('generated-sku');
            element.innerText = variation.sku;
            if( ! element.classList.contains('active') ){
                element.classList.add('active')
            }
        }

    })
    
    $( 'form.variations_form' ).on( 'found_variation', function( event, variation ) {
        document.getElementById('custom-stock').innerHTML = variation.availability_html;
    })

    $( '.reset_variations' ).on( 'click', ()=>{
        
        // reset sku
        let element = document.getElementById('generated-sku');
        if(element){
            element.innerText = '';
            if( element.classList.contains('active') ){
                element.classList.remove('active')
            }
        }
        
        // reset stock/price
        document.getElementById('custom-stock').innerHTML = '';
        document.getElementById('custom-price').innerHTML = '';

    });

    /**
     * 
     * Updates the variation price under the product title
     * https://developer.mozilla.org/en-US/docs/Web/API/MutationObserver
     * 
     */
    function listen_for_variation_price_change(){

        let variation_wrapper = document.querySelector('.woocommerce-variation.single_variation');

        if( variation_wrapper ){

            function observe_variation_price_change(mutationList, observer){

                for (const mutation of mutationList) {
                    if (mutation.type === "childList") {
                        let price = mutation.target.querySelector('.woocommerce-variation-price');
                        $('#custom-price').html( price.innerHTML );
                    }
                }

            };

            const variation_observer = new MutationObserver(observe_variation_price_change);
            variation_observer.observe(variation_wrapper, { attributes: false, childList: true, subtree: true });

        }
    }
    listen_for_variation_price_change();





    // Replaces AOS (change animations in _animations.scss)

    // https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
    // https://blog.webdevsimplified.com/2022-01/intersection-observer/


    let product_title = document.querySelector('h1.product_title');
    
    if( product_title ){

        const title_observer = new IntersectionObserver( ( entries, observer ) => {
            entries.forEach( entry => {
                if(entry.isIntersecting){
                    $('.product-banner').fadeOut();
                }
                if( ! entry.isIntersecting ){
                    $('.product-banner').fadeIn();
                }
            });
        });

        title_observer.observe(product_title);
    }

    $(".single_variation_wrap").on("show_variation", (e, variation) => {
        if( variation.sku ){
            $('.product-banner__sku').html( variation.sku );
        }
        if( variation.price_html ){
            $('.product-banner__price').html( variation.price_html );
        }
    });

    $( '.reset_variations' ).on( 'click', () => {
        let banner = document.querySelector('.product-banner');

        if( banner ){
            $('.product-banner__sku').html( banner.dataset.sku );
            $('.product-banner__price').html( banner.dataset.price );
        }

    });

});